import { Injectable } from '@angular/core';


import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { getQueryParameter, menus } from 'src/app/utils';
import { Store } from '@ngrx/store';
import { PagesState } from '../pages/pages.model';
import { WSSState } from './wss.model';
import { LogedIn, SessionId } from './wss.actions';
import { ActiveCalls, GotAccount, GotLoginData, GotMyPicture, GotUsers, NotifyUser, ShowError, ShowWelcome, UserRoll } from '../pages/pages.actions';
import { customerId, myId, sessionId } from './wss.selectors';
import { CalendarState } from '../pages/scheduling/calendar.model';
import { ClendarUser } from '../pages/scheduling/calendar.actions';

import * as CryptoTS from 'crypto-ts';
import { NewInitials, NewSignature } from '../canvas/canvas.actions';
import { codeFromURL, myCompany, workTime } from '../pages/pages.selectors';
import { TrainingState } from '../training/training.model';
import { GotPatients } from '../training/training.actions';
declare var kzLib: any;


@Injectable({
  providedIn: 'root'
})
export class KeyziiService {
  // user: SocialUser | undefined;
  cookie_pwd: string | undefined

  customer_id: string | undefined
  my_id: string | undefined
  menus: any[] = []
  company: string = "keyzii"
  work_time: any
  code_from_url: string | undefined
  login_as: string | undefined
  bIsMaster: boolean = false

  session_id: string | undefined
  constructor(
    // private socialAuthService: SocialAuthService,
    private httpClient: HttpClient,
    public router: Router,
    private pagesState: Store<PagesState>,
    private wssState: Store<WSSState>,
    private calendarStore: Store<CalendarState>,
    public trainingStore: Store<TrainingState>,
  ) {
    this.menus = menus
    console.log("KeyziiService ")
    this.login_as = getQueryParameter("email")
    let me = this
    async function gotKzLibMsg(msg: any) {
      console.log(JSON.stringify(msg))
      if (msg.app == "email_login") {
        if (msg.width) {
          window.resizeTo(msg.width, msg.height)
        }
        if (msg.session_id) {
          try {
            await me.setProxySession(msg.session_id)
          } catch (e) {
            console.error(e)
          }
        }
        try {
          await me.contLogInWithEmail(msg.data)
        } catch (e) {
          console.error(e)
        }
      }
    }
    if (typeof kzLib != 'undefined') {
      if (kzLib.bIsMaster) {
        kzLib.registerCallBack(gotKzLibMsg)
      }
    }
    if (this.login_as) {
      let token = getQueryParameter("token")
      if (token) {
        this.loginAsEmail(this.login_as, token)
      }
    }
    this.wssState.select(sessionId).subscribe((session_id: string | undefined) => {
      this.session_id = session_id

    })

    this.pagesState.select(codeFromURL).subscribe((code_from_url: string | undefined) => {

      this.code_from_url = code_from_url

    })
    this.pagesState.select(myCompany).subscribe((company: string) => {
      if (company) {
        this.company = company
      }
    })
    this.pagesState.select(workTime).subscribe((work_time: any) => {
      if (work_time) {
        this.work_time = work_time
      }
    })
    this.wssState.select(myId).subscribe((my_id: string | undefined) => {
      this.my_id = my_id
    })
    this.wssState.select(customerId).subscribe((customer_id: string | undefined) => {
      if (!this.customer_id && customer_id) {
        this.customer_id = customer_id
        this.getAccount()
        //  <!-- <script src="assets/api/site/kzmLoader.js" id="kz" no_btn="true" rep_id="6692df35c53600249985507f"> </script> -->
        /*

        sergio@venditio.us in dev , rep_id="6692df35c53600249985507f"
        sergio@venditio.us Company in dev ,customer_id="6692df35c53600249985507e"

        sergio@venditio.us script in test ,rep_id="604cfa8e196fdb0888e68103"
        sergio@venditio.us Company in test ,customer_id="604cfa8e196fdb0888e68102"


        Miguel's script in test,  customer_id="623de9b42540e1787ab059b1"
        Miguel's script in production, customer_id="624dd98826ad13509e9d1412"

        //load this when the customer_id is venditio
        <script src="assets/api/p2p/kzLib.js"></script> <!-- allwos you control of the site on a call -->


        */


      }
    })

  }
  async  setProxySession(session_id: string) {
    return new Promise(async (resolve, reject) => {
      try {
        let rv: any = await this.httpClient.post('/proxi', { session_id: session_id }).toPromise();
        resolve(rv)
      } catch (e) {
        reject(e)
      }
    })
  }
  getCookies() {
    if (this.cookie_pwd) {
      let signature = this.getCookie("signature")
      if (signature) {
        let data = JSON.parse(signature)
        this.calendarStore.dispatch(new NewSignature(data.group_id, data.svg, data.rect, data.text_initials))
      }
      let initials = this.getCookie("initials")
      if (initials) {
        let data = JSON.parse(initials)
        this.calendarStore.dispatch(new NewInitials(data.group_id, data.svg, data.rect))
      }
    }
  }

  public logIntWithSession(token: string) {
    return new Promise(async (resolve, reject) => {
      try {
        let rv: any = await this.httpClient.get('/token/' + token).toPromise();
        if (rv.welcome) {
          this.pagesState.dispatch(new ShowWelcome(rv.welcome))
        }
        // if (rv.ask_code_from) {
        //   this.pagesState.dispatch(new AskCodeFrom(rv.ask_code_from))
        // }
        this.calendarStore.dispatch(new ClendarUser(rv))
        this.wssState.dispatch(new LogedIn(rv))
        this.pagesState.dispatch(new GotLoginData(rv))
        this.pagesState.dispatch(new UserRoll(rv.roll))
        if (rv.patients) {
          this.trainingStore.dispatch(new GotPatients(rv.patients))
        }
        this.cookie_pwd = rv.cookie_pwd
        this.getCookies()
        // if (!rv.has_google_calendar && window.location.host.indexOf("localhost") < 0) {
        //   this.pagesState.dispatch(new ShowError("It looks like your calendar is not connected. Please re-connect your calendar in settings."))
        // }
        resolve(rv)

      } catch (e: any) {
        reject(e);
      }
    })
  }

  public loginWithEmail(email: string, pwd: string) {
    return new Promise(async (resolve, reject) => {
      try {
        let body = {
          email: email.toLowerCase(),
          pwd: pwd,
        }
        let rv: any = await this.httpClient.post('/login', body).toPromise();
        let rv1 = await this.contLogInWithEmail(rv)
        if (typeof kzLib != 'undefined') {
          if (!kzLib.bIsMaster) {
            let msg = {
              app: "email_login",
              data: rv,
              session_id: this.session_id,
              width: window.innerWidth,
              height: window.innerHeight
            }
            kzLib.sendMsg(msg)
            console.log("kzlib lg --> " + JSON.stringify(msg))
          }
        }
        if (this.login_as && rv.email_token) {
          let url = window.location.href + "?email=" + this.login_as + "&token=" + rv.email_token
          window.location.assign(url);
        }
        resolve(rv1)
      } catch (e: any) {
        reject(e);
      }
    })
  }
  async  loginAsEmail(email: string, token: string) {
    return new Promise(async (resolve, reject) => {
      try {
        let body = {
          email: email.toLowerCase(),
          email_token: token,
        }
        let rv: any = await this.httpClient.post('/login_as', body).toPromise();
        let rv1 = await this.contLogInWithEmail(rv)


        resolve(rv1)
      } catch (e: any) {
        reject(e);
      }
    })
  }
  contLogInWithEmail(rv: any) {
    return new Promise(async (resolve, reject) => {
      try {
        if (rv.welcome) {
          this.pagesState.dispatch(new ShowWelcome(rv.welcome))
        }
        // if (rv.ask_code_from) {
        //   this.pagesState.dispatch(new AskCodeFrom(rv.ask_code_from))
        // }
        this.calendarStore.dispatch(new ClendarUser(rv))
        this.wssState.dispatch(new LogedIn(rv))
        this.pagesState.dispatch(new GotLoginData(rv))
        this.pagesState.dispatch(new UserRoll(rv.roll))
        if (rv.patients) {
          this.trainingStore.dispatch(new GotPatients(rv.patients))
        }
        this.cookie_pwd = rv.cookie_pwd
        this.getCookies()
        // if (!rv.has_google_calendar && window.location.host.indexOf("localhost") < 0) {
        //   this.pagesState.dispatch(new ShowError("It looks like your calendar is not connected. Please re-connect your calendar in settings."))
        // }
        resolve(rv)

      } catch (e: any) {
        reject(e);
      }
    })
  }
  signUp(email: string, name?: string, last_name?: string, company?: string) {
    return new Promise(async (resolve, reject) => {
      try {
        let body = {
          email: email.toLowerCase(),
          name: name,
          last_name: last_name,
          company: company,
          code_from_url: this.code_from_url
        }
        let rv: any = await this.httpClient.post('/signup', body).toPromise();

        this.calendarStore.dispatch(new ClendarUser(rv))
        resolve(rv)
      } catch (e: any) {
        console.error(JSON.stringify(e))
        reject(e);
      }
    })
  }
  resetPWd(token: string, email: string, pwd: string) {
    return new Promise(async (resolve, reject) => {
      try {
        let body = {
          token: token,
          pwd: pwd,
          email: email.toLowerCase()
        }
        let rv: any = await this.httpClient.post('/reset', body).toPromise();
        let rv1 = await this.contLogInWithEmail(rv)
        if (typeof kzLib != 'undefined') {
          if (!kzLib.bIsMaster) {
            let msg = {
              app: "email_login",
              data: rv,
              session_id: this.session_id,
              width: window.innerWidth,
              height: window.innerHeight
            }
            kzLib.sendMsg(msg)
            console.log("kzlib re --> " + JSON.stringify(msg))

          }
        }
        resolve(rv1)
        // this.pagesState.dispatch(new LogedIn(rv))
        // this.pagesState.dispatch(new GotLoginData(rv))
        // this.pagesState.dispatch(new UserRoll(rv.roll))
        // if (rv.welcome) {
        //   this.pagesState.dispatch(new ShowWelcome(rv.welcome))
        // }

      } catch (e: any) {
        if (e.error.desc == "New user") {
          let new_user = {
            email: e.error.email
          }
          resolve(new_user)
          this.pagesState.dispatch(new LogedIn(new_user))
        }
        // console.error(e)
        reject(e);
      }
    })
  }
  logOut() {
    // if (this.user) {
    //   this.socialAuthService.signOut(true)
    // }
    location.reload();
  }
  getActiveCalls(page: number, page_size: number, agency: number, search: string) {
    return new Promise<any>(async (resolve, reject) => {
      try {
        let url: string = '/active_calls?&page=' + page + "&page_size=" + page_size

        let rv: any = await this.httpClient.get(url).toPromise();
        /*  if (rv.calls.length == 0) {
            rv.count = 14
            rv.calls = [{
              caller_email: "Sergio@asci.us",
              caller_name: "Sergio",
              rep_email: "ts1@asas.xx",
              rep_name: "ts ts",
              started_at: 1723306281637,
            }, {
              caller_email: "Sergio@asci.us",
              caller_name: "Sergio",
              rep_email: "ts2@asas.xx",
              rep_name: "ts ts",
              started_at: 1723326281637,
            }, {
              caller_email: "Sergio@asci.us",
              caller_name: "Sergio",
              rep_email: "ts3@asas.xx",
              rep_name: "ts ts",
              started_at: 1723306281637,
            }, {
              caller_email: "Sergio@asci.us",
              caller_name: "Sergio",
              rep_email: "ts4@asas.xx",
              rep_name: "ts ts",
              started_at: 1723326281637,
            }, {
              caller_email: "Sergio@asci.us",
              caller_name: "Sergio",
              rep_email: "ts5@asas.xx",
              rep_name: "ts ts",
              started_at: 1723306281637,
            }, {
              caller_email: "Sergio@asci.us",
              caller_name: "Sergio",
              rep_email: "ts6@asas.xx",
              rep_name: "ts ts",
              started_at: 1723326281637,
            }, {
              caller_email: "Sergio@asci.us",
              caller_name: "Sergio",
              rep_email: "ts7@asas.xx",
              rep_name: "ts ts",
              started_at: 1723306281637,
            }, {
              caller_email: "Sergio@asci.us",
              caller_name: "Sergio",
              rep_email: "ts8@asas.xx",
              rep_name: "ts ts",
              started_at: 1723326281637,
            }]
          }*/
        this.pagesState.dispatch(new ActiveCalls(rv))

        resolve(rv)
      } catch (e: any) {
        reject(e);
      }
    })
  }

  async getAccount() {
    try {
      let url = '/account/' + this.customer_id
      let account: any = await this.httpClient.get(url).toPromise();
      this.pagesState.dispatch(new GotAccount(account))
    } catch (e: any) {
      console.error("Error getAccount  " + JSON.stringify(e))
    }
  }

  async addUser(user: any) {
    return new Promise<any>(async (resolve, reject) => {
      try {
        let user1 = Object.assign({}, user)
        user1.company = this.company
        user1.work_time = this.work_time
        let msg = { user: user1, customer_id: this.customer_id, }
        let new_user = await this.httpClient.post<any[]>('/users', msg).toPromise();
        resolve(new_user)
      } catch (e: any) {
        reject(e)
      }
    })
  }

  async editUser(user: any) {
    try {
      let msg = { user: user, customer_id: this.customer_id }
      let users_reps = await this.httpClient.put<any[]>('/users', msg).toPromise();
      this.pagesState.dispatch(new GotUsers(users_reps))
    } catch (e: any) {
      console.error("Error editUser  " + JSON.stringify(e))
    }
  }

  async deleteUser(user: any) {
    try {
      console.log("del user " + JSON.stringify(user))
      let users_reps = await this.httpClient.put<any[]>('/del_users/', { user: user }).toPromise();
      this.getUsersAndReps()
    } catch (e: any) {
      console.error("Error del user " + JSON.stringify(e))
    }
  }
  async setUserData(data: any) {
    try {
      let rv: any = await this.httpClient.put<any[]>('/user_data', data).toPromise();
      this.pagesState.dispatch(new GotUsers(rv.users))
    } catch (e: any) {
      console.error("Error editUser show " + JSON.stringify(e))
    }
  }
  async saveUserPicture(picture: any) {
    try {
      let rv: any = await this.httpClient.post('/save_rep_pic', { picture: picture }).toPromise();
    } catch (e: any) {
      console.error("Error delete user picture" + JSON.stringify(e))
    }
  }
  async setAPIIParams(params: any) {
    try {
      let rv: any = await this.httpClient.post("/api_params", params).toPromise();
    } catch (e) {
      console.error("Error setAPIIFrameURL  " + e)
    }
  }
  async delUserPicture() {
    try {
      let rv: any = await this.httpClient.delete('/del_rep_pic').toPromise();
    } catch (e: any) {
      console.error("Error delete user picture" + JSON.stringify(e))
    }
  }
  async setCompanyData(data: any) {
    try {
      let users_reps = await this.httpClient.put<any[]>('/company_data', data).toPromise();
      this.pagesState.dispatch(new NotifyUser("Saved"))
    } catch (e: any) {
      console.error("Error editUser show " + JSON.stringify(e))
    }
  }
  async getUsersAndReps() {
    return new Promise<any>(async (resolve, reject) => {

      try {
        let users_reps = await this.httpClient.get<any[]>('/users').toPromise();
        this.pagesState.dispatch(new GotUsers(users_reps))
      } catch (e: any) {
        console.error("Error editUser show " + JSON.stringify(e))
      }
    })
  }
  setCookie(name: string, sval: any) {
    if (this.cookie_pwd) {
      const ciphertext = CryptoTS.AES.encrypt(sval, this.cookie_pwd);
      let enc_val = ciphertext.toString();
      localStorage.setItem(name, enc_val)
    }
  }
  getCookie(name: string) {
    let plaintext = ""
    let enc_val = localStorage.getItem(name)
    if (enc_val && this.cookie_pwd) {
      try {
        const bytes = CryptoTS.AES.decrypt(enc_val, this.cookie_pwd);
        plaintext = bytes.toString(CryptoTS.enc.Utf8);
      } catch (e) {

      }
    }
    return plaintext;
  }
  async getUserPicture() {
    return new Promise<any>(async (resolve, reject) => {
      try {
        let user = await this.httpClient.get<any>('/user_pic').toPromise();
        console.log("<-- user " + JSON.stringify(user))
        this.pagesState.dispatch(new GotMyPicture(user.picture)) //let the other parts know
        resolve(user)
      } catch (e: any) {
        reject("Error editUser show " + JSON.stringify(e))

      }
    })
  }

}
